import type {QueryClient} from '@tanstack/react-query'

import {projectKeys} from './query-keys'

/** Drop cached project billable line items after charges change on a job or project. */
export function invalidateProjectBillableLineItemsQueries(
    queryClient: QueryClient,
    projectId: string,
) {
    void queryClient.invalidateQueries({queryKey: projectKeys.billableLineItems(projectId)})
    void queryClient.invalidateQueries({queryKey: projectKeys.detail(projectId)})
}
